import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  errors,
  valid,
} from "../../../../common/Validator";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import { DATE_FORMAT_INPUT} from "../../../../utils/config"
import {withRouter} from 'react-router-dom'
import { getProfileInfo} from "../../../../redux/action/profileInfoAction"
import { connect } from "react-redux";
// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateProject Component for updating the project details.
 */
class UpdateProjectDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectname: this.props.updateDataProp
        ? this.props.updateDataProp.projectName
        : "",
      customername: this.props.updateDataProp
        ? this.props.updateDataProp.customerName
        : "",
      duration: this.props.updateDataProp
        ? this.props.updateDataProp.duration
        : "",
      fromdate: this.props.updateDataProp
        ? this.isDateFormat(this.props.updateDataProp.fromDate)
        : "",
      todate: this.props.updateDataProp ? this.isDateFormat(this.props.updateDataProp.toDate) : "",
      projectdescription: this.props.updateDataProp
        ? this.props.updateDataProp.projectDescription
        : "",
      skillset: this.props.updateDataProp
        ? this.props.updateDataProp.skillSet
        : "",
      role: this.props.updateDataProp ? this.props.updateDataProp.role : "",
      tools: this.props.updateDataProp
        ? this.props.updateDataProp.toolsAndTechnologies
        : "",
      responsibilities: this.props.updateDataProp
        ? this.props.updateDataProp.responsibilities
        : "",
      todateback: "",
      fromdateback: "",
      durationback: "",
      dateError: "",
      errorYear:"",
      toErrorYear:"",

      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined,
      message: "",
      error: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.isDateFormat = this.isDateFormat.bind(this)

    this.dateOnChange = this.dateOnChange.bind(this);
  }

  // common onchange function

  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  // date format validation
  isDateFormat(data) {
    let date = new Date(data);
   
    let year = date.getFullYear();
    let day = date.getDate();
    let month = date.getMonth() ;


    console.log(year,day,date,month)
    if (`${day}`.length === 1) day = `0${day}`;
    if (`${month}`.length === 1) month = `0${month}`;
    if (DATE_FORMAT_INPUT === "YYYY-MM-DD") return `${year}-${month}-${day}`;

    return `${month}-${day}-${year}`;

  
  }

  // submit function by clicking submit button
    onSubmit  (e) {
    e.preventDefault();
    submitValidator(e.target);
   
    
    let datePartOne = this.state.fromdate.split('-')
    let dateFrom = new Date(datePartOne[0], datePartOne[1],datePartOne[2] )

    let datePartTwo = this.state.todate.split('-')
    let dateTo = new Date( datePartTwo[0],  datePartTwo[1], datePartTwo[2] )
 

    let data = {
      canInfoId:this.props.profile.data.id,
      projectName: this.state.projectname,
      customerName: this.state.customername,
      
      duration: Number(this.state.duration),
      fromDate: this.state.fromdate,
      toDate: this.state.todate,
      projectDescription: this.state.projectdescription,
      skillSet: this.state.skillset,
      responsibilities: this.state.responsibilities,
      role: this.state.role,
      toolsAndTechnologies: this.state.tools,
    };
   
    if (valid && !this.state.dateError&& !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-project`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response && !err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
    // update function by clicking update button
  onUpdate(e) {
 
    e.preventDefault();
    submitValidator(e.target);

    let datePartOne = this.state.fromdate.split('-')
    let dateFrom = new Date(datePartOne[0], datePartOne[1],datePartOne[2] )

    let datePartTwo = this.state.todate.split('-')
    let dateTo = new Date( datePartTwo[0],  datePartTwo[1], datePartTwo[2] )
    
    let data = {
      id: this.state.id,
      canInfoId:this.props.profile.data.id,
      projectName: this.state.projectname,
      customerName: this.state.customername,

      duration: Number(this.state.duration),
      fromDate: this.state.fromdate,
      toDate: this.state.toDate,
      projectDescription: this.state.projectdescription,
      skillSet: this.state.skillset,
      responsibilities: this.state.responsibilities,
      role: this.state.role,
      toolsAndTechnologies: this.state.tools,
    };
    if (valid && !this.state.dateError&& !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-project`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {

          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // onchange function for to date and from date
  dateOnChange(e) {
    if (e.target.name === "fromdate") {
      let date = new Date(e.target.value);
      let dateYear = date.getFullYear();


      if ((dateYear.toString().length < 4 || dateYear.toString().length > 4)|| (dateYear > new Date(Date.now()).getFullYear()) )  {
        this.setState({
          errorYear: "please enter valid date",
        });
      } else {
        this.setState({
          errorYear: "",
        });
      }
      this.setState({
        todate: "",
      });
      errors.fromdate = "";
    }
    if (e.target.name === "todate") {
      let dateTo = new Date(e.target.value);
      let dateYearTo = dateTo.getFullYear();

      if (
        dateYearTo.toString().length < 4 ||
        dateYearTo.toString().length > 4 ||
        dateYearTo > new Date(Date.now()).getFullYear()
      ) {
        this.setState({
          toErrorYear: "please enter valid date",
          dateError: "",
        });
      } else {
        this.setState({
          toErrorYear: "",
        });
      }
      
      if (
        Date.parse(e.target.value) < Date.parse(this.state.fromdate) ||
        !this.state.fromdate
      ) {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "EndDate must be greater than or equal to StartDate",
          toErrorYear:""
        });
        errors.todate = "";
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "",
        });
        errors.todate = "";

        console.log(e.target.value);
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
      errors.fromdate = "";
    }
  }

  componentDidMount() {
    this.props.getProfileInfo();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
    const {
      projectname,
      customername,
      duration,
      fromdate,
      todate,
      projectdescription,
      role,
      tools,
      responsibilities,
      skillset,
      message,
      error,
    } = this.state;

    return (
      <>
        {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Project Details</span>
              </div>

              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                       index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Project Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="projectname"
                        inputClass="form-control-sm"
                        value={projectname}
                        change={this.onChange}
                        required={true}
                      />
                    

                         <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="From Date"
                        type="date"
                        name="fromdate"
                        inputClass="form-control-sm"
                        value={fromdate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Duration(Years)"
                        type="number"
                        name="duration"
                        inputClass="form-control-sm"
                        value={duration}
                        change={this.onChange}
                        required={true}
                      />
                    
                   
                      <FormComponent
                        index="7"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Skill Set"
                        type="textarea"
                        name="skillset"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={skillset}
                        change={this.onChange}
                        required={true}
                      />
                          <FormComponent
                           index="9"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Role"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="role"
                        inputClass="form-control-sm"
                        value={role}
                        change={this.onChange}
                        required={true}
                      />
                    </Col>
                    <Col md="6">
                    <FormComponent
                    index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Customer Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="customername"
                        inputClass="form-control-sm"
                        value={customername}
                        change={this.onChange}
                        required={true}
                      />
                         <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="To Date"
                        type="date"
                        name="todate"
                        inputClass="form-control-sm"
                        value={todate}
                        change={this.dateOnChange}
                        min={this.state.fromdate}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                     
                      <FormComponent
                      index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Project Description"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="projectdescription"
                        inputClass="form-control-sm"
                        value={projectdescription}
                        change={this.onChange}
                        required={true}
                      />

                  
                      <FormComponent
                        index="8"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Tools & Technologies"
                        type="textarea"
                        name="tools"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={tools}
                        change={this.onChange}
                        required={true}
                      />
                    
                      <FormComponent
                      index="10"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Responsibilities"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="responsibilities"
                        inputClass="form-control-sm"
                        value={responsibilities}
                        change={this.onChange}
                        required={true}
                      />
                    
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="11"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "20px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Project Details</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                <Row>
                <Col md="6">
                      <FormComponent
                       index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Project Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="projectname"
                        inputClass="form-control-sm"
                        value={projectname}
                        change={this.onChange}
                        required={true}
                      />
                        <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="From Date"
                        type="date"
                        name="fromdate"
                        inputClass="form-control-sm"
                        value={fromdate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                    

                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Duration(Years)"
                        type="number"
                        name="duration"
                        inputClass="form-control-sm"
                        value={duration}
                        change={this.onChange}
                        required={true}
                      />
                    
                    
                      <FormComponent
                        index="7"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Skill Set"
                        type="textarea"
                        name="skillset"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={skillset}
                        change={this.onChange}
                        required={true}
                      />
                          <FormComponent
                           index="9"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Role"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="role"
                        inputClass="form-control-sm"
                        value={role}
                        change={this.onChange}
                        required={true}
                      />
                    </Col>
                    <Col md="6">
                    <FormComponent
                    index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Customer Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="customername"
                        inputClass="form-control-sm"
                        value={customername}
                        change={this.onChange}
                        required={true}
                      />
                        <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="To Date"
                        type="date"
                        name="todate"
                        inputClass="form-control-sm"
                        value={todate}
                        change={this.dateOnChange}
                        min={this.state.fromdate}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                     
                      <FormComponent
                      index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Project Description"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="projectdescription"
                        inputClass="form-control-sm"
                        value={projectdescription}
                        change={this.onChange}
                        required={true}
                      />

                  
                      <FormComponent
                        index="8"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Tools & Technologies"
                        type="textarea"
                        name="tools"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={tools}
                        change={this.onChange}
                        required={true}
                      />
                    
                      <FormComponent
                      index="10"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Responsibilities"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="responsibilities"
                        inputClass="form-control-sm"
                        value={responsibilities}
                        change={this.onChange}
                        required={true}
                      />
                    
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex="11"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "10px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateProjectDetails)
);